export const seasonalConfigs = {
  SEASON_END: 2024,
  SEASON_END_CLUB_TITLE: 2023,
  TOTAL_GAMES:"82"
}

export const SEASON_END = "SEASON_END"
export const SEASON_END_CLUB_TITLE = "SEASON_END_CLUB_TITLE"
export const TOTAL_GAMES = "TOTAL_GAMES"
